import queryString from './src/query-string';

export type * from './src/query-string';
export * from './src/query-string';
export default queryString;
